import React, { useState, useEffect } from "react";
import "./Distances.css";
import { useStateValue } from "./StateProvider";
import { holes } from "./CourseInfo";

function Distances() {
  const [{ user }] = useStateValue();
  const [{ hole }] = useStateValue();
  const [greenCoord, setGreenCoord] = useState();
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [accuracy, setAccuracy] = useState();
  const [front, setFront] = useState();
  const [center, setCenter] = useState();
  const [back, setBack] = useState();
  // const [pin, setPin] = useState();

  useEffect(() => {
    setGreenCoord([]);
    // getLocation()
    // fetchHoleLocations();
    setLatitude("");
    setLongitude("");
    setAccuracy("")
    setFront("");
    setBack("");
    setCenter("");
    // setPin("");
  }, [hole]);


  //get distances from firebase ********************NOT USED
  //once accurate save in Course Info
  // const fetchHoleLocations = async () => {
  //   var coordinates = [];
  //   const ev = await db
  //     .collection("courselocations")
  //     .doc("hole" + hole)
  //     .collection("green")
  //     .get()
  //     .then((querySnapshot) => {
  //       querySnapshot.forEach((doc) => {
  //         coordinates.push({
  //           location: doc.id,
  //           lat: doc.data().lat,
  //           long: doc.data().long,
  //         });
  //       });
  //     });
  //   setGreenCoord(coordinates);
  // };

 

  const getLocation = () => {
    if (navigator.geolocation) {
      //set up for loop to get more accuracy
      //Dummy one, which will result in a working next statement.
     

      for (let i = 0; i < 5; i++) {
      navigator.geolocation.getCurrentPosition(
        function () {},
        function () {},
        { enableHighAccuracy: true, timeout: 2000, maximumAge: 0}
      );}

      // let acc
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // acc = position.coords.accuracy.toFixed(2);
          setAccuracy(position.coords.accuracy.toFixed(2));
          setLatitude (position.coords.latitude.toFixed(13));
          setLongitude(position.coords.longitude.toFixed(13));
          getAllDistances(position.coords.latitude, position.coords.longitude);
           // if accuracy > 7 metres search again
          if(position.coords.accuracy > 7){getLocation()} 
        },
        (error) => {
          if(error.message==="Timeout expired"){
          alert("Limited Accuracy Acheivable")}
        else{
        alert(error.message)}},
        { enableHighAccuracy: true, timeout: 20000, maximumAge: 0}
      );
    }
  };


  const getAllDistances = (lat, long) => {
      setFront(getDistanceFromLatLonInYds(lat, long, holes[hole].greenfront[0], holes[hole].greenfront[1]).toFixed(0));
      setCenter(getDistanceFromLatLonInYds(lat, long, holes[hole].greencenter[0], holes[hole].greencenter[1]).toFixed(0));
      setBack(getDistanceFromLatLonInYds(lat, long, holes[hole].greenback[0], holes[hole].greenback[1]).toFixed(0));
      // const Pin = greenCoord.find((c) => c.location === "pin");      If retreived from firebase
      // setPin(
      //   getDistanceFromLatLonInYds(lat, long, Pin.lat, Pin.long).toFixed(0)
      // );
    
  };

  const getDistanceFromLatLonInYds = (lat1, lon1, lat2, lon2) => {
    let R = 6975240.5949256; // Radius of the earth in yards
    let dLat = deg2rad(lat2 - lat1); // deg2rad below
    let dLon = deg2rad(lon2 - lon1);
    let a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let d = R * c; // Distance in yards
    return d;
  };

  const deg2rad = (deg) => {
    return deg * (Math.PI / 180);
  };

  return (
    <div className="finddistances">
      {/* {user.email==="docdatainc@gmail.com" && latitude && <div> {latitude}, {longitude}</div>} */}
      <div className="distances__container">
        <div className="dist__button">
          <button onClick={() => getLocation()}>Distances</button>
        </div>
        <div className="table__container">
        <table className="dist_table">
          <tbody>
        <tr className="dist__labels">
          {/* <header className="green"> */}
            
              <th>Front</th>
              <th>Center</th>
              <th>Back</th>
              {/* <th>Pin</th> */}
            
          {/* </header> */}
          </tr>
          {/* <body> */}
            <tr className="distances">
              <td>{front}</td>
              <td>{center}</td>
              <td>{back}</td>
              {/* <td>{pin}</td> */}
            </tr>
          {/* </body> */}
          </tbody>
        </table>
        
        </div>
        <div  className="acc__container" >
        {accuracy &&
        <div className="accuracy">
        <div><span className="acc__title">Accuracy</span></div>
        <div><span className="acc"> +/-{(accuracy*1.0936133).toFixed(0)} </span></div>
        </div>}
        </div>
      </div>

      <div className="loc__coords">
        <table>
        <tbody>
        <tr>
        <td>Your location</td>
        <td>{latitude}, {longitude}  </td>
        </tr>
        </tbody>
        </table>
      </div>
     
      
    </div>
  );
}

export default Distances;
